export const COUNTRIES_MAP = {
  AFG: 'Afghanistan',
  ZAF: 'Afrique du Sud',
  ALB: 'Albanie',
  DZA: 'Algérie',
  DEU: 'Allemagne',
  AND: 'Andorre',
  AGO: 'Angola',
  ATG: 'Antigua-et-Barbuda',
  SAU: 'Arabie saoudite',
  ARG: 'Argentine',
  ARM: 'Arménie',
  AUS: 'Australie',
  AUT: 'Autriche',
  AZE: 'Azerbaïdjan',
  BHS: 'Bahamas',
  BHR: 'Bahreïn',
  BGD: 'Bangladesh',
  BRB: 'Barbade',
  BLR: 'Bélarus',
  BEL: 'Belgique',
  BLZ: 'Belize',
  BEN: 'Bénin',
  BTN: 'Bhoutan',
  BOL: 'Bolivie (État plurinational de)',
  BIH: 'Bosnie-Herzégovine',
  BWA: 'Botswana',
  BRA: 'Brésil',
  BRN: 'Brunéi Darussalam',
  BGR: 'Bulgarie',
  BFA: 'Burkina Faso',
  BDI: 'Burundi',
  KHM: 'Cambodge',
  CMR: 'Cameroun',
  CAN: 'Canada',
  CPV: 'Cabo Verde',
  CHL: 'Chili',
  CHN: 'Chine',
  CYP: 'Chypre',
  COL: 'Colombie',
  COM: 'Comores',
  COG: 'Congo',
  CRI: 'Costa Rica',
  CIV: 'Côte d\'Ivoire',
  HRV: 'Croatie',
  CUB: 'Cuba',
  DNK: 'Danemark',
  DJI: 'Djibouti',
  DMA: 'Dominique',
  EGY: 'Égypte',
  SLV: 'El Salvador',
  ARE: 'Émirats arabes unis',
  ECU: 'Équateur',
  ERI: 'Érythrée',
  ESP: 'Espagne',
  EST: 'Estonie',
  SWZ: 'Eswatini',
  USA: 'États-Unis d’Amérique',
  ETH: 'Éthiopie',
  RUS: 'Fédération de Russie',
  FJI: 'Fidji',
  FIN: 'Finlande',
  FRA: 'France',
  GAB: 'Gabon',
  GMB: 'Gambie',
  GEO: 'Géorgie',
  GHA: 'Ghana',
  GRC: 'Grèce',
  GRD: 'Grenade',
  GTM: 'Guatemala',
  GIN: 'Guinée',
  GNQ: 'Guinée équatoriale',
  GNB: 'Guinea-Bissau',
  GUY: 'Guyana',
  HTI: 'Haïti',
  HND: 'Honduras',
  HUN: 'Hongrie',
  FRO: 'Îles Féroé',
  MHL: 'Îles Mashall',
  SLB: 'Îles Salomon',
  IND: 'Inde',
  IDN: 'Indonésie',
  IRN: 'Iran (Republique islamique d’)',
  IRQ: 'Iraq',
  IRL: 'Irlande',
  ISL: 'Islande',
  ISR: 'Israël',
  ITA: 'Italie',
  JAM: 'Jamaïque',
  JPN: 'Japon',
  JOR: 'Jordanie',
  KAZ: 'Kazakhstan',
  KEN: 'Kenya',
  KGZ: 'Kirgizistan',
  KIR: 'Kiribati',
  KWT: 'Koweït',
  LSO: 'Lesotho',
  LTU: 'Lituanie',
  LBN: 'Liban',
  LBR: 'Libéria',
  LBY: 'Libye',
  LIE: 'Liechtenstein',
  LVA: 'Lettonie',
  LUX: 'Luxembourg',
  MKD: 'Macédoine du Nord',
  MDG: 'Madagascar',
  MYS: 'Malaisie',
  MWI: 'Malawi',
  MDV: 'Maldives',
  MLI: 'Mali',
  MLT: 'Malte',
  MAR: 'Maroc',
  MUS: 'Maurice',
  MRT: 'Mauritanie',
  MEX: 'Mexique',
  FSM: 'Micronésie (États fédérés de)',
  MCO: 'Monaco',
  MNG: 'Mongolie',
  MNE: 'Monténégro',
  MOZ: 'Mozambique',
  MMR: 'Myanmar',
  NAM: 'Namibie',
  NRU: 'Nauru',
  NPL: 'Népal',
  NIC: 'Nicaragua',
  NER: 'Niger',
  NGA: 'Nigéria',
  NIU: 'Nioué',
  NOR: 'Norvège',
  NZL: 'Nouvelle-Zélande',
  OMN: 'Oman',
  UGA: 'Ouganda',
  UZB: 'Ouzbékistan',
  PAK: 'Pakistan',
  PLW: 'Palaos',
  PAN: 'Panama',
  PNG: 'Papouasie-Nouvelle-Guinée',
  PRY: 'Paraguay',
  NLD: 'Pays-Bas',
  PER: 'Pérou',
  PHL: 'Philippines',
  POL: 'Pologne',
  PRI: 'Porto Rico',
  PRT: 'Portugal',
  QAT: 'Qatar',
  SYR: 'République arabe syrienne',
  CAF: 'République centrafricaine',
  KOR: 'République de Corée',
  COD: 'République démocratique du Congo',
  LAO: 'République démocratique populaire lao',
  MDA: 'République de Moldova',
  DOM: 'République dominicaine',
  PRK: 'République populaire démocratique de Corée',
  TZA: 'République-Unie de Tanzanie',
  REU: 'Réunion',
  ROU: 'Roumanie',
  GBR: 'Royaume-Uni de Grande-Bretagne et d\'Irlande du Nord',
  RWA: 'Rwanda',
  KNA: 'Saint-Kitts-et-Nevis',
  LCA: 'Sainte-Lucie',
  SMR: 'Saint-Marin',
  VAT: 'Saint-Siège',
  VCT: 'Saint-Vincent-et-les Grenadines',
  WSM: 'Samoa',
  STP: 'Sao Tomé-et-Principe',
  SEN: 'Sénégal',
  SRB: 'Serbie',
  SYC: 'Seychelles',
  SLE: 'Sierra Leone',
  SGP: 'Singapour',
  SVK: 'Slovaquie',
  SVN: 'Slovénie',
  SOM: 'Somalie',
  SDN: 'Soudan',
  SSD: 'Soudan du Sud',
  LKA: 'Sri Lanka',
  SWE: 'Suède',
  CHE: 'Suisse',
  SUR: 'Suriname',
  TJK: 'Tadjikistan',
  TCD: 'Tchad',
  CZE: 'Tchéquie',
  PSE: 'Palestine',
  THA: 'Thaïlande',
  TLS: 'Timor-Leste',
  TGO: 'Togo',
  TKL: 'Tokélaou',
  TON: 'Tonga',
  TTO: 'Trinité-et-Tobago',
  TUN: 'Tunisie',
  TKM: 'Turkménistan',
  TUR: 'Turquie',
  TUV: 'Tuvalu',
  UKR: 'Ukraine',
  URY: 'Uruguay',
  VUT: 'Vanuatu',
  VEN: 'Venezuela (République bolivarienne du)',
  VNM: 'Viet Nam',
  YEM: 'Yémen',
  ZMB: 'Zambie',
  ZWE: 'Zimbabwe',
};

export const COUNTRIES_CODE_MAP = {
  afghanistan: 'AFG',
  albania: 'ALB',
  algeria: 'DZA',
  andorra: 'AND',
  angola: 'AGO',
  'antigua and barbuda': 'ATG',
  argentina: 'ARG',
  armenia: 'ARM',
  australia: 'AUS',
  austria: 'AUT',
  azerbaijan: 'AZE',
  bahamas: 'BHS',
  bahrain: 'BHR',
  bangladesh: 'BGD',
  barbados: 'BRB',
  belarus: 'BLR',
  belgium: 'BEL',
  belize: 'BLZ',
  benin: 'BEN',
  bhutan: 'BTN',
  'bolivia (plurinational state of)': 'BOL',
  'bosnia and herzegovina': 'BIH',
  botswana: 'BWA',
  brazil: 'BRA',
  'brunei darussalam': 'BRN',
  bruneidarussalam: 'BRN',
  bulgaria: 'BGR',
  'burkina faso': 'BFA',
  burundi: 'BDI',
  cambodia: 'KHM',
  cameroon: 'CMR',
  canada: 'CAN',
  'cabo verde': 'CPV',
  'central african republic': 'CAF',
  chad: 'TCD',
  chile: 'CHL',
  china: 'CHN',
  colombia: 'COL',
  comoros: 'COM',
  congo: 'COG',
  'costa rica': 'CRI',
  'côte d\'ivoire': 'CIV',
  croatia: 'HRV',
  cuba: 'CUB',
  cyprus: 'CYP',
  czechia: 'CZE',
  'democratic people\'s republic of korea': 'PRK',
  'democratic republic of the congo': 'COD',
  denmark: 'DNK',
  djibouti: 'DJI',
  dominica: 'DMA',
  'dominican republic': 'DOM',
  ecuador: 'ECU',
  egypt: 'EGY',
  'el salvador': 'SLV',
  'equatorial guinea': 'GNQ',
  eritrea: 'ERI',
  estonia: 'EST',
  ethiopia: 'ETH',
  fiji: 'FJI',
  finland: 'FIN',
  france: 'FRA',
  gabon: 'GAB',
  gambia: 'GMB',
  georgia: 'GEO',
  germany: 'DEU',
  ghana: 'GHA',
  greece: 'GRC',
  grenada: 'GRD',
  guatemala: 'GTM',
  guinea: 'GIN',
  'guinea-bissau': 'GNB',
  guyana: 'GUY',
  haiti: 'HTI',
  honduras: 'HND',
  hungary: 'HUN',
  iceland: 'ISL',
  india: 'IND',
  indonesia: 'IDN',
  'iran (islamic republic of)': 'IRN',
  iraq: 'IRQ',
  ireland: 'IRL',
  israel: 'ISR',
  italy: 'ITA',
  jamaica: 'JAM',
  japan: 'JPN',
  jordan: 'JOR',
  kazakhstan: 'KAZ',
  kenya: 'KEN',
  kiribati: 'KIR',
  kuwait: 'KWT',
  kyrgyzstan: 'KGZ',
  'lao people\'s democratic republic': 'LAO',
  latvia: 'LVA',
  lebanon: 'LBN',
  lesotho: 'LSO',
  liberia: 'LBR',
  libya: 'LBY',
  liechtenstein: 'LIE',
  lithuania: 'LTU',
  luxembourg: 'LUX',
  madagascar: 'MDG',
  malawi: 'MWI',
  malaysia: 'MYS',
  maldives: 'MDV',
  mali: 'MLI',
  malta: 'MLT',
  'marshall islands': 'MHL',
  mauritania: 'MRT',
  mauritius: 'MUS',
  mexico: 'MEX',
  'micronesia (federated states of)': 'FSM',
  monaco: 'MCO',
  mongolia: 'MNG',
  montenegro: 'MNE',
  morocco: 'MAR',
  mozambique: 'MOZ',
  myanmar: 'MMR',
  namibia: 'NAM',
  'republic of nauru': 'NRU',
  nepal: 'NPL',
  netherlands: 'NLD',
  'new zealand': 'NZL',
  nicaragua: 'NIC',
  niger: 'NER',
  nigeria: 'NGA',
  niue: 'NIU',
  norway: 'NOR',
  'Palestine': 'PSE',
  oman: 'OMN',
  pakistan: 'PAK',
  palau: 'PLW',
  panama: 'PAN',
  'papua new guinea': 'PNG',
  paraguay: 'PRY',
  peru: 'PER',
  philippines: 'PHL',
  poland: 'POL',
  portugal: 'PRT',
  'puerto rico (united states of america)': 'PRI',
  qatar: 'QAT',
  'republic of korea': 'KOR',
  'republic of moldova': 'MDA',
  romania: 'ROU',
  'russian federation': 'RUS',
  rwanda: 'RWA',
  samoa: 'WSM',
  'saint kitts and nevis': 'KNA',
  'saint lucia': 'LCA',
  'saint vincent and the grenadines': 'VCT',
  'san marino': 'SMR',
  'sao tome and principe': 'STP',
  'saudi arabia': 'SAU',
  senegal: 'SEN',
  serbia: 'SRB',
  seychelles: 'SYC',
  'sierra leone': 'SLE',
  singapore: 'SGP',
  slovakia: 'SVK',
  slovenia: 'SVN',
  somalia: 'SOM',
  'solomon islands': 'SLB',
  'south africa': 'ZAF',
  'south sudan': 'SSD',
  spain: 'ESP',
  'sri lanka': 'LKA',
  sudan: 'SDN',
  'sudan (pre-2011)': 'SDN',
  suriname: 'SUR',
  eswatini: 'SWZ',
  sweden: 'SWE',
  switzerland: 'CHE',
  'syrian arab republic': 'SYR',
  tajikistan: 'TJK',
  thailand: 'THA',
  'north macedonia': 'MKD',
  'timor-leste': 'TLS',
  togo: 'TGO',
  tokelau: 'TKL',
  tonga: 'TON',
  'trinidad and tobago': 'TTO',
  tunisia: 'TUN',
  turquie: 'TUR',
  turkmenistan: 'TKM',
  tuvalu: 'TUV',
  uganda: 'UGA',
  ukraine: 'UKR',
  'united arab emirates': 'ARE',
  'united kingdom of great britain and northern ireland': 'GBR',
  'united republic of tanzania': 'TZA',
  'united states of america': 'USA',
  uruguay: 'URY',
  uzbekistan: 'UZB',
  vanuatu: 'VUT',
  'venezuela (bolivarian republic of)': 'VEN',
  'viet nam': 'VNM',
  yemen: 'YEM',
  zambia: 'ZMB',
  zimbabwe: 'ZWE',
};
